interface TierNames {
  [key: number]: string
}
export const Tiers: TierNames = {
  1: 'Bronze',
  2: 'Silver',
  3: 'Gold',
  4: 'Platinum',
  5: 'Diamond',
  6: 'Master',
}
